@if (isLoading()) {
  <!-- Loading State -->
  <div class="loading-state">
    <app-loader></app-loader>
    <p>Loading your W9 form...</p>
  </div>

} @else if (!w9Form()) {
  <!-- Empty State -->
  <div class="sales-dashboard-counter">
    <mat-card>
      <mat-card-content>
        <div class="form-card">
          <h3>
            <i class="fa-solid fa-file-pdf" style="opacity: 0.9; color: #028da8;"></i>
            W9 Tax Form
          </h3>

          <div class="empty-state">
                <a mat-raised-button color="primary"  (click)="goToW9()"><mat-icon>edit</mat-icon> Complete W9 Form</a>
            </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

} @else {
  <!-- W9 Form Found -->
  <div class="sales-dashboard-counter">
    <mat-card>
      <mat-card-content>
        <div class="form-card">
          <h3>
            <i class="fa-solid fa-file-pdf" style="opacity: 0.9; color: #028da8;"></i>
            W9 Tax Form
          </h3>

          <div class="status">
            <div class="label">Status</div>
            <div class="status-text">
              <i class="fa-solid {{ w9Form()?.formStatus === 'Approved' ? 'fa-check' : 'fa-hourglass-half'}}"
                 [class.primary-green]="w9Form()?.formStatus === 'Approved'">
              </i>
              {{ w9Form()?.formStatus }}
            </div>
          </div>

          <a mat-raised-button color="primary" [href]="w9Form()?.formUrl" target="_blank">
            <mat-icon>download</mat-icon> View Document
          </a>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
}